import { Button, Form, Input, message, Popover, Table, Tooltip } from "antd";
import { useEffect, useState } from "react";
import { startCase } from "lodash";
import { RiFileExcel2Line, RiMailSendLine } from "react-icons/ri";
import {
  blobToDataUrl,
  ExportToExcel,
  getExportData,
} from "../../../utils/exportExcel";

import postDataMain from "../../../services/postDataMail";
import fetchDataRoad from "../../../services/fetchDataRoad";
import Manage from "..";
import { FiEdit } from "react-icons/fi";
import { IoTrashBinOutline } from "react-icons/io5";
import CreateUser from "./components/CreateUser";

export default function Users() {
  const [selected, setSelected] = useState<any>({});
  const [isLoading, setLoading] = useState<boolean>(false);
  const [isMailLoading, setMailLoading] = useState<boolean>(false);
  const [createModal, setCreateModal] = useState<boolean>(false);
  const [messageModal, toggleMessageModal] = useState(false);
  const [updateModal, setUpdateModal] = useState<boolean>(false);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [technicians, setTechnicians] = useState([]);

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    limit: 10,
  });

  const [emailForm] = Form.useForm();

  const hanleFetchData = async () => {
    const uri = "users";
    const response = await fetchDataRoad({ uri });
    if (response?.success) {
      setTechnicians(response?.payload);
    }
  };

  const sendMail = async (values: any) => {
    setMailLoading(true);
    const data = technicians?.map((item: any, index: number) => {
      return {
        "S/N": index + 1,
        Name: item?.name === null ? "-" : item?.name,
        Address: item?.address === null ? "-" : item?.address,
        Email: item?.email === null ? "-" : item?.email,
        Mobile: item?.mobile === null ? "-" : item?.mobile,
        Active: item?.isActive ? "Yes" : "No",
      };
    });

    const raw = getExportData(data);
    const uri = await blobToDataUrl(raw);

    const maildata = {
      email: values.email,
      subject: values.subject,
      data: uri,
    };

    const mailuri = "mail";

    await postDataMain(maildata, mailuri);
    setMailLoading(false);

    message.success("Email Sent Successfully");
    emailForm.resetFields();
    toggleMessageModal(false);
  };

  const columns = [
    {
      title: "S/N",
      width: 20,
      render: (record: any, text: any, index: any) => (
        <span className="text-gray-700 ml-2">{index + 1}</span>
      ),
    },
    {
      title: "Name",
      width: 150,
      render: (record: any) => {
        const name = record?.name;
        return (
          <span className="text-gray-700">
            {startCase(name?.toLowerCase())}
          </span>
        );
      },
    },
    {
      title: "Mobile",
      width: 50,
      render: (record: any) => (
        <span className="text-gray-700">
          {record?.mobile === null ? "-" : record?.mobile}
        </span>
      ),
    },
    {
      title: "Email",
      width: 90,
      render: (record: any) => (
        <span className="text-gray-700">
          {record?.email === null ? "-" : record?.email}
        </span>
      ),
    },
    {
      title: "Address",
      width: 80,
      render: (record: any) => (
        <span className="text-gray-700">
          {record?.address === null ? "-" : record?.address}
        </span>
      ),
    },

    {
      title: "Action",
      width: 40,
      render: (record: any) => (
        <div className="flex justify-start">
          <button
            onClick={() => {
              setSelected({
                ...record,
              });
              setUpdateModal(true);
            }}
            className="flex justify-center items-center text-gray-700 border rounded-md p-2 bg-gray-100 hover:bg-gray-200 cursor-pointer"
          >
            <FiEdit />
          </button>
          <button
            onClick={() => {
              setSelected({
                ...record,
              });
              setDeleteModal(true);
            }}
            className="flex justify-center items-center ml-1 text-gray-700 border rounded-md p-2 bg-red-100 hover:bg-red-200 cursor-pointer"
          >
            <IoTrashBinOutline />
          </button>
        </div>
      ),
    },
  ];

  useEffect(() => {
    hanleFetchData();
  }, []);

  return (
    <Manage
      title={"Users"}
      subtitle={"All"}
      description={"List of all users"}
      actions={
        <div className="flex">
          <Popover
            content={
              <>
                <Form
                  name="basic"
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                  initialValues={{ remember: true }}
                  form={emailForm}
                  onFinish={sendMail}
                  autoComplete="off"
                >
                  <Form.Item
                    label="Email"
                    name="email"
                    rules={[{ required: true, message: "Email is Required" }]}
                  >
                    <Input placeholder="Email" />
                  </Form.Item>
                  <Form.Item
                    label="Subject"
                    name="subject"
                    rules={[{ required: true, message: "Subject is Required" }]}
                  >
                    <Input placeholder="Email Subject" />
                  </Form.Item>
                  <div className="flex flex-row justify-between">
                    <Form.Item wrapperCol={{ offset: 12, span: 8 }}>
                      <Button type="primary" htmlType="submit">
                        {isMailLoading ? "Sending ..." : "Submit"}
                      </Button>
                    </Form.Item>

                    <Form.Item wrapperCol={{ offset: 0, span: 8 }}>
                      <Button
                        onClick={() => {
                          toggleMessageModal(false);
                        }}
                      >
                        Cancel
                      </Button>
                    </Form.Item>
                  </div>
                </Form>
              </>
            }
            title="Message Content"
            trigger="focus"
            placement="left"
            visible={messageModal}
          >
            <Tooltip title="Send Email">
              <button
                className="flex ml-2 justify-center items-center border px-4 py-1 hover:bg-gray-100"
                onClick={async () => {
                  toggleMessageModal(true);
                }}
              >
                <RiMailSendLine size={21} />
              </button>
            </Tooltip>
          </Popover>
          <Tooltip title="Export To Excel">
            <button
              color="#E50000"
              className="flex mx-2 justify-center items-center border px-4 py-1 hover:bg-gray-100"
              onClick={() =>
                ExportToExcel(
                  technicians?.map((item: any, index: number) => {
                    return {
                      "S/N": index + 1,
                      Name: item?.name === null ? "-" : item?.name,
                      Address: item?.address === null ? "-" : item?.address,
                      Email: item?.email === null ? "-" : item?.email,
                      Mobile: item?.mobile === null ? "-" : item?.mobile,
                      Active: item?.isActive ? "Yes" : "No",
                    };
                  }),
                  "Technicians.xlsx"
                )
              }
            >
              <RiFileExcel2Line size={20} />
            </button>
          </Tooltip>
          <Button onClick={() => setCreateModal(true)}>+ New</Button>
          <CreateUser
            isVisible={createModal}
            setVisible={setCreateModal}
            refetch={hanleFetchData}
          />
        </div>
      }
    >
      <>
        <div className="flex flex-col">
          <div className="flex flex-col w-full">
            <div className="grid gap-x-0 grid-cols-12">
              <div className="col-span-12 sm:col-span-12 md:col-span-12">
                <Table
                  size="small"
                  dataSource={isLoading ? [] : technicians}
                  columns={columns}
                  pagination={pagination}
                  scroll={{ y: 660, x: 0 }}
                  rowKey="id"
                  loading={isLoading}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    </Manage>
  );
}
